var _style, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowserstack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F4B960;}\r\n\t.st1{fill:#E66F32;}\r\n\t.st2{fill:#E43C41;}\r\n\t.st3{fill:#BDD041;}\r\n\t.st4{fill:#6DB54C;}\r\n\t.st5{fill:#AEDAE6;}\r\n\t.st6{fill:#56B8DE;}\r\n\t.st7{fill:#00B1D5;}\r\n\t.st8{fill:url(#SVGID_1_);}\r\n\t.st9{fill:#221F1F;}\r\n\t.st10{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.599)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.424199 0 0 1.424199 -9.93078 -12.725966)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 52.2,
    cy: 40.6,
    r: 17.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 50.5,
    cy: 38.8,
    r: 15.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 52.6,
    cy: 36.8,
    r: 13.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 53.7,
    cy: 37.8,
    r: 12.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 52.8,
    cy: 38.8,
    r: 11.7
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 50.9,
    cy: 36.9,
    r: 9.8
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 52.5,
    cy: 35.2,
    r: 8.2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 53.5,
    cy: 36.4,
    r: 7.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 67.1525,
    cy: 47.5996,
    r: 12.5032,
    gradientTransform: "matrix(0.7048 0 0 -0.7048 5.1437 70.9742)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#797979"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C"
    }
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 52.5,
    cy: 37.3,
    r: 6.1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 52.5,
    cy: 37.3,
    r: 6.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4094 -0.9124 0.9124 0.4094 0.3944 70.8633)",
    className: "st10",
    cx: 54.9,
    cy: 35.1,
    rx: 1.9,
    ry: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserstack);
export default __webpack_public_path__ + "static/media/Browserstack.f416e3b075555f194f0b784c7166863a.svg";
export { ForwardRef as ReactComponent };